import type { ProductsFeatureConfig } from '@shared/products-feature-configs';

export const products: ProductsFeatureConfig = {
    relyOnPAPIEndpointsForData: false,
    relyOnGAPIForAggregation: true,
    flagAndFeatureDrivenSelfServicing: false,
    fieldsWithGAPIPriority: [],
};
